module.exports = __webpack_public_path__ + "fonts/SFUIText-HeavyItalic.f0d79b28.woff2";